<template>
  <Form
    ref="form"
    inline
    :model="form"
  >
    <FormItem prop="keyword">
      <Input
        v-model="form.keyword"
        style="width: 320px"
        placeholder="请输入广告主公司名称/帐号/客户编号/产品名"
        clearable
      />
    </FormItem>

    <FormItem prop="status">
      <Select
        v-model="form.status"
        placeholder="客保状态"
        clearable
      >
        <Option
          v-for="item in status"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </Select>
    </FormItem>

    <FormItem prop="step_id">
      <Select
        v-model="form.step_id"
        placeholder="跟进状态"
        clearable
      >
        <Option
          v-for="item in status2"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </Select>
    </FormItem>

    <FormItem prop="over_day">
      <Select
        v-model="form.over_day"
        placeholder="释放时间"
        clearable
      >
        <Option
          v-for="item in release"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </Select>
    </FormItem>

    <FormItem prop="order_by">
      <Select
        v-model="form.order_by"
        placeholder="排序"
        clearable
      >
        <Option
          v-for="item in order"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </Select>
    </FormItem>

    <FormItem>
      <Button
        type="primary"
        @click="search"
      >
        查询
      </Button>
      <Button @click="reset">
        重置
      </Button>
    </FormItem>
  </Form>
</template>

<script>
import { Form, FormItem, Input, Select, Option, Button } from 'element-ui';

export default {
  components: {
    Form,
    FormItem,
    Input,
    Select,
    Option,
    Button,
  },

  data() {
    return {
      form: {
        keyword: undefined,
        status: undefined,
        step_id: undefined,
        over_day: undefined,
        order_by: undefined,
      },
      status: [
        {
          value: 1,
          label: '新开',
        },
        {
          value: 2,
          label: '再次新开',
        },
        {
          value: 3,
          label: '公示中',
        },
      ],
      status2: [
        {
          value: 1,
          label: '跟进',
        },
        {
          value: 2,
          label: '广告主接洽',
        },
        {
          value: 3,
          label: '合作提案',
        },
        {
          value: 4,
          label: '开户（开户中）',
        },
      ],
      release: [
        {
          value: 1,
          label: '3天内即将释放',
        },
        {
          value: 2,
          label: '7天内将释放',
        },
      ],
      order: [
        {
          value: 0,
          label: '按照释放倒序排序',
        },
        {
          value: 1,
          label: '按产品归属时间排序',
        },
      ],
    };
  },

  methods: {
    search() {
      this.$refs.form.validate((valid) => {
        this.$emit('search', this.form);
      });
    },

    getParams() {
      return this.form;
    },

    reset() {
      this.$refs.form.resetFields();
      this.$emit('search', this.form);
    },
  },
};
</script>